/**
 * TaskStatusBadge Component
 *
 * Displays status badge for tasks
 *
 * @module components/tasks/shared/TaskStatusBadge
 */

import React from 'react';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * TaskStatusBadge Component
 *
 * @param {Object} props
 * @param {string} props.status - Status: 'pending', 'in_progress', 'completed'
 * @param {string} props.className - Additional CSS classes
 */
const TaskStatusBadge = ({ status, className = '' }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'pending':
        return {
          variant: 'warning',
          text: 'Pendiente',
          icon: 'bi-clock-fill'
        };
      case 'in_progress':
        return {
          variant: 'info',
          text: 'En Progreso',
          icon: 'bi-arrow-repeat'
        };
      case 'completed':
        return {
          variant: 'success',
          text: 'Completada',
          icon: 'bi-check-circle-fill'
        };
      default:
        return {
          variant: 'secondary',
          text: 'Sin estado',
          icon: 'bi-circle'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge
      bg={config.variant}
      className={`task-status-badge d-inline-flex align-items-center gap-1 ${className}`}
    >
      <i className={`bi ${config.icon}`} style={{ fontSize: '0.875rem' }}></i>
      <span>{config.text}</span>
    </Badge>
  );
};

TaskStatusBadge.propTypes = {
  status: PropTypes.oneOf(['pending', 'in_progress', 'completed']).isRequired,
  className: PropTypes.string
};

export default TaskStatusBadge;
